import { render, staticRenderFns } from "./SurplusManagerDashboard.vue?vue&type=template&id=67a3f0ac&scoped=true&"
import script from "./SurplusManagerDashboard.vue?vue&type=script&lang=js&"
export * from "./SurplusManagerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SurplusManagerDashboard.vue?vue&type=style&index=0&id=67a3f0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3f0ac",
  null
  
)

export default component.exports